import { EMPTY } from '@shared/utils/strings';
export function formatLenght(lenght, unit = 'm') {
    return `${lenght}${unit}`;
}
export function formatOptionalLenght(lenght, unit = 'm', defaultString = EMPTY) {
    return lenght === undefined || lenght === null ? defaultString : formatLenght(lenght, unit);
}
